export default __webpack_public_path__ + "static/media/home1280x720.671949ed.mp4";